import {ChangeDetectionStrategy, Component, computed} from "@angular/core"
import {ButtonComponent} from "@common/components/buttons/button/button.component"
import {OperatorRotate} from "@app/textures/texture-editor/operator-stack/operators/rotate/operator-rotate"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {OperatorPanelBase} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator-panel-base"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-rotate-panel",
    templateUrl: "./rotate-panel.component.html",
    styleUrls: ["./rotate-panel.component.scss"],
    imports: [ButtonComponent, InspectorSectionComponent],
})
export class RotatePanelComponent extends OperatorPanelBase<OperatorRotate> {
    readonly $angleInDegrees = computed(() => this.$operator().$angleInDegrees())

    protected setAngleInDegrees(value: number) {
        this.$operator().setAngleInDegrees(value)
    }
}
